import { createContext, useContext, useEffect } from "react"

export type RegisterAdminDirty = (key: string, dirty: boolean) => void

export const AdminUnsavedChangesContext = createContext<RegisterAdminDirty | null>(null)

export function useRegisterAdminDirty(key: string, dirty: boolean) {
  const registerDirty = useContext(AdminUnsavedChangesContext)

  useEffect(() => {
    registerDirty?.(key, dirty)
    return () => registerDirty?.(key, false)
  }, [dirty, key, registerDirty])
}
